import { Component } from 'preact';
import style from './styles/BirthdayInput.scss';
import CustomDropDown from './dropdown/CustomDropDown';
import CustomDropDownOption from './dropdown/CustomDropDownOption';

/**
 * @property {Function} props.onChangeAction
 * @property {number} props.day
 * @property {number} props.month
 * @property {number} props.year
 */
export default class BirthdayInput extends Component {

	months = [];
	years = [];

	/**
	 * @param {number} month
	 * @param {number} year
	 * @return {Array}
	 */
	getDaysInMonth (month, year) {
		const days = [];
		const dayCount = new Date(year, month, 0).getDate();
		for (let i = 1; i <= dayCount; i++) {
			days.push(i);
		}
		return days;
	}

	/**
	 * @return {Array}
	 */
	generateYears () {
		const years = [];
		const currentYear = new Date().getFullYear();
		const toYear = currentYear - 6;
		const fromYear = toYear - 100;
		for (let i = toYear; i >= fromYear; i--) {
			years.push(i);
		}
		return years;
	}

	/**
	 * @this BirthdayInput
	 */
	onDayChange = (day) => {
		this.props.onChangeAction(this.props.name, {
			day
		});
	};

	/**
	 * @this BirthdayInput
	 */
	onMonthChange = (month) => {
		this.props.onChangeAction(this.props.name, {
			month
		});
		this.updateDayIfRequired(this.props.year || this.state.initialYear, month);
	};

	/**
	 * @this BirthdayInput
	 */
	onYearChange = (year) => {
		this.props.onChangeAction(this.props.name, {
			year
		});
		this.updateDayIfRequired(year, this.props.month || this.state.initialMonth);
	};

	updateDayIfRequired = (year, month) => {
		// heads up! Date's under/overflowing behaviour allows to get maximum day in the month
		// the month is not decremented intentionally!
		const maxDay = new Date(year, month, 0).getDate();
		if (this.props.day > maxDay) {
			this.props.onChangeAction(this.props.name, {
				day: maxDay
			});
		}
	};

	constructor(props) {
		const { onChangeAction } = props;
		if (!(onChangeAction instanceof Function)) {
			new Error('BirthdayInput expects onChangeAction prop to be a defined Function.');
		}
		super(props);
		this.years = this.generateYears();
		this.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
		const initialYear = this.years[0];
		const initialMonth = this.months[0];
		const initialDay = 1;
		this.state = { initialYear, initialMonth, initialDay };
	}

	render({ name, year = null, month = null, day = null, parentWasValidated }) {
		const isRequired = (year && month && day) || (parentWasValidated && (year || month || day));
		const yearSelected = year !== null;
		const monthSelected = month !== null;
		const daySelected = day !== null;
		const isValid = yearSelected && monthSelected && daySelected;
		return (
			<div class={`input-group ${style.birthday}` + (isValid ? ` ${style.valid}` : (isRequired ? ` ${style.required}` : ''))}>
				<CustomDropDown title={daySelected ? day.padLeft(2) : 'Day'} className={`${style.left} ${style['time-dropdown']} ${style['with-separator']}`}>
					{this.getDaysInMonth(month, year).map((day) => <CustomDropDownOption value={day} label={day.padLeft(2)} onChange={this.onDayChange} />)}
				</CustomDropDown>
				<CustomDropDown title={monthSelected ? (month).padLeft(2) : 'Month'} className={`${style.middle} ${style['time-dropdown']} ${style['with-separator']}`}>
					{this.months.map((month) => <CustomDropDownOption value={month} label={(month).padLeft(2)} onChange={this.onMonthChange} />)}
				</CustomDropDown>
				<CustomDropDown title={yearSelected ? year : 'Year'} className={`${style.right} ${style['time-dropdown']}`}>
					{this.years.map((year) => <CustomDropDownOption value={year} label={year} onChange={this.onYearChange} />)}
				</CustomDropDown>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/form/BirthdayInput.js